import { LanguageDirection, Languages } from '../entities';

const rtlLanguages = [Languages.AR, Languages.HE, Languages.FA, Languages.UR];

export const getLanguageDirection = (locale: Languages) => {
  return rtlLanguages.includes(locale) ? LanguageDirection.RTL : LanguageDirection.LTR;
};
